import { Modal } from 'bootstrap'
import Cookies  from 'js-cookie'

window.culligan = window.culligan || {}

/**
 * Show the email signup modal when the user has 
 * scrolled halfway down the page.
 */
if (
  // 1) User hasn't seen the modal in 7 day.
  ! Cookies.get('hasSeenAutoEmailSignupModal') && (

    // 2) We're on a blog page and the config setting is active.
    (window.location.pathname.substr(0, 5) == '/blog' && window.culligan.autoOpenEmailSignUpBlog) ||

    // 3) or we're on a problem page and the config setting is active.
    (window.location.pathname.substr(0, 9) == '/problems' && window.culligan.autoOpenEmailSignUpProblems)
  )
) {
  let hasSeenAutoEmailSignupModal = false

  window.addEventListener('scroll', function() {
    if (! hasSeenAutoEmailSignupModal) {
      const currentScrollPosition = window.scrollY
      const totalScrollableHeight = document.documentElement.scrollHeight - window.innerHeight
      const halfwayPoint = totalScrollableHeight / 2

      if (currentScrollPosition >= halfwayPoint) {
        const emailSignupModal = Modal.getOrCreateInstance('#email-sign-up-form-modal');
        emailSignupModal.show()

        hasSeenAutoEmailSignupModal = true
        Cookies.set('hasSeenAutoEmailSignupModal', 1, {expires: 7, path: '/'})
      }
    }
  })
}
